// Hook that hands a ready-to-call Api instance to pages.
// Memoized per sign-in — we don't want a new Api object every render.

import { useMemo } from "react";
import { Api } from "./api";
import { useAuth } from "./auth";

export function useApi(): Api {
  const { getIdToken } = useAuth();
  return useMemo(() => new Api({ getIdToken }), [getIdToken]);
}
